import { Link } from 'react-router-dom';

const furtherMaterials = [
  {
    title: 'Оценка и развитие сотрудников',
    desc: 'Как определить компетенции, потенциал и зоны развития.',
    to: '/razvitie-personala/otsenka-i-razvitie-sotrudnikov',
  },
  {
    title: 'Развитие персонала',
    desc: 'Системный подход к развитию сотрудников.',
    to: '/razvitie-personala',
  },
  {
    title: 'Наставничество',
    desc: 'Как развивать сотрудников через передачу опыта и практику.',
    to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov',
  },
  {
    title: 'Корпоративная академия',
    desc: 'Как построить системную систему обучения внутри компании.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
  },
  {
    title: 'Менеджмент и лидерство',
    desc: 'Развитие руководителей и управленческих компетенций.',
    to: '/menedzhment-i-liderstvo',
  },
];

export default function StudyFurtherSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что изучить дальше
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Материалы, которые помогут глубже разобраться в индивидуальном развитии сотрудников.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {furtherMaterials.map((item, i) => (
            <Link
              key={i}
              to={item.to}
              className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 hover:shadow-lg transition-all group cursor-pointer"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{item.desc}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 group-hover:text-teal-700 transition-colors">
                Подробнее
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}